import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    isIOS,
    IOSView,
} from "react-device-detect";
// import TagManager from 'react-gtm-module'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn } from '@fortawesome/free-solid-svg-icons';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    card: {
        minWidth: 275,
    },
    JobsTitle:{color: theme.palette.primary.main,
        textAlign: 'center',
        fontWeight: 'bold',
        margin: '12px 0',

    },
    jobDescription:{
        textAlign: 'center',
        backgroundColor: theme.palette.primary.main,
        padding: 25,
        color: 'white',
        margin: 0
    },
    cardContentIFrame:{
        padding: 0,
        overflow: isIOS ? 'scroll' : 'hidden',
        width: '100%',
        overflowScrolling: "touch",
        WebkitOverflowScrolling: "touch",
        textAlign: 'center',
        paddingTop: '12px'
    },
    myjobIOSIFrame:{
        width: '94%',
        [theme.breakpoints.down('sm')]: {
            width: isIOS ? '393px' : '94%',
        },
        [theme.breakpoints.up('md')]: {
            width: '94%',
        },
    },
});

class JobsWidget extends Component{
    render(){
    const { classes } = this.props;
    return(       
        <div className={classes.root}>
            <Typography component="h3" variant="h6" className={classes.JobsTitle} gutterBottom>
            WE'RE HIRING NOW! <FontAwesomeIcon icon={faBullhorn} />
            </Typography>
            <Grid container
            direction="row"
            justify="center"
            alignItems="center">
                <Grid item xs={12}>
                    <Card className={classes.card}>
                        {/* <Typography component="h1" variant="h6" className={classes.jobDescription} gutterBottom>
                            We're Hiring
                        </Typography> */}
                        <CardContent className={classes.cardContentIFrame}>
                            <iframe id="typeform-full"
                                className={classes.myjobIOSIFrame}
                                width="94%" height="730px" frameBorder="0"
                                src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/static/myjobs/duwun-hiring-jobs.html"></iframe>
                        </CardContent>
                        <br />
                        <br />
                    </Card>
                </Grid>
            </Grid>
        </div>     
        )
    }
  }


export default withStyles(styles)(JobsWidget);
